/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var creategafCookie = function(name, value, days){
    if (days) {
        var expiry = new Date();
        expiry.setTime(expiry.getTime()+(days*24*60*60*1000));
        var expires = "; expires=" + expiry.toGMTString();
    } else {
        var expires = "";
    }
    document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
}

var readgafCookie = function(name){
    var nameEQ = escape(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
        c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
        return unescape(c.substring(nameEQ.length, c.length));
    }
    return null;
}
document.addEventListener('product:added', function(event) {
    var popxmaspopupCookie = readgafCookie('popxmaspopup');
    if(popxmaspopupCookie != 'yes'){
      $('.popxmaspopup').css('display', 'flex');
      creategafCookie('popxmaspopup', 'yes', 1);
    }
});


$(function(){
  
 icon_bg_mobile_slider();
  function icon_bg_mobile_slider(){
    if($('.size-comparison-wall .scw-lists').length){
    if ($(window).width() < 640) {
           $('.size-comparison-wall .scw-lists').slick({
                dots: true,
                arrows:true,
                speed: 500,
                rtl: true,
                initialSlide:0, 
            });
          }else{
            if($('.size-comparison-wall .scw-lists').hasClass('slick-initialized')) {
            $('.size-comparison-wall .scw-lists').slick('unslick');
            }
          }
    }

    }


  
  $(window).on('resize', function() {
    icon_bg_mobile_slider();
  });
})

